import React from 'react';

const Tabs = ({ active, onChange }) => {
  return (
    <div className="tabs-container">
      <div className="tabs-wrapper">
        <button
          onClick={() => onChange('documents')}
          className={`tab-button ${
            active === 'documents'
              ? 'tab-button-active'
              : ''
          }`}
        >
          Documents
        </button>
        <button
          onClick={() => onChange('activity')}
          className={`tab-button ${
            active === 'activity'
              ? 'tab-button-active'
              : ''
          }`}
        >
          Recent Activity
        </button>
      </div>
    </div>
  );
};

export default Tabs;
